import { Injectable } from '@angular/core';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { LotNaljepniceService } from '../pages/lot-naljepnice/lot-naljepnice.service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfZaIzdatniceLotSirovinaPojedinacnoService {
  constructor(private service: LotNaljepniceService) {}

  pdfZaIzdatniceLotSirovinPojedinacnoService(dataJedneNaljepnice) {
    console.log('DATA JEDNE NALJEPNICE: ', dataJedneNaljepnice);

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    let ct = [];
    // let docDefinition: any = [];

    ct.push({
      columns: [
        {
          table: {
            widths: [235],
            heights: [85],
            body: [
              [
                {
                  table: {
                    body: [
                      [
                        {
                          text: 'Pekar d.o.o. Obrtnička 5 Vinkovci  \n',
                          style: 'title',
                        },
                      ],

                      [
                        {
                          text: '\n',
                          style: 'title',
                        },
                      ],

                      [
                        {
                          text: dataJedneNaljepnice.po_naziv,
                          style: 'subtitle',
                        },
                      ],

                      [
                        {
                          text: '\n',
                          style: 'title',
                        },
                      ],

                      [
                        {
                          text:
                            dataJedneNaljepnice.ar_sifra +
                            ' ' +
                            dataJedneNaljepnice.ar_naziv,
                          style: 'subtitle',
                        },
                      ],

                      [
                        {
                          text: '\n',
                          style: 'title',
                        },
                      ],

                      [
                        {
                          text: 'LOT oznaka: ' + dataJedneNaljepnice.ar_lot,
                          style: 'subtitle',
                          bold: true
                        },
                      ],

                      [
                        {
                          text: '\n',
                          style: 'title',
                        },
                      ],

                      [
                        {
                          text:
                            'Nabavljeno/proizvedeno: ' +
                            '\n' +
                            //dataJedneNaljepnice.do_datum,
                            `${dataJedneNaljepnice.do_datum != null ? dataJedneNaljepnice.do_datum : dataJedneNaljepnice.pz_datum != null ? dataJedneNaljepnice.pz_datum : '/'}`,
                          style: 'subtitle',
                        },
                      ],

                      [
                        {
                          text:
                            'Rok trajanja: ' +
                            '\n' +
                            //dataJedneNaljepnice.do_datum_vazido,
                            `${dataJedneNaljepnice.do_datum_vazido != null ? dataJedneNaljepnice.do_datum_vazido : dataJedneNaljepnice.ps_vazido != null ? moment(dataJedneNaljepnice.ps_vazido).format('DD.MM.YYYY') : '/'}`,
                          style: 'subtitle',
                        },
                      ],

                      [
                        {
                          text: '\n',
                          style: 'title',
                        },
                      ],

                      [
                        {
                          qr:
                            /*
                            dataJedneNaljepnice.po_sifra +
                            ';' +
                            dataJedneNaljepnice.ar_sifra +
                            ';' +
                            */
                            dataJedneNaljepnice.ar_lot,
                            /*
                            ';' +
                            dataJedneNaljepnice.do_datum +
                            ';' +
                            dataJedneNaljepnice.do_datum_vazido,
                            */
                          style: 'subtitle',
                        },
                      ],
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
            ],
          },
        },
      ],
    });

    var docDefinition: any = {
      /* 1 mm = 2.835 pt ==> naljepnica je 10cm X 12,5cm (100mm * 2.835 = 283.5) */
      pageSize: { width: 283.5 , height: 'auto' },
      content: ct,

      info: {
        title: 'Ispis naljepnica LOT: ' + dataJedneNaljepnice.ar_lot,
      },

      pageMargins: 20,
      defaultStyle: {
        fontSize: 7.5,
      },
      styles: {
        title: {
          fontSize: 12,
          bold: true,
        },
        subtitle: {
          fontSize: 10,
        },
        details: {
          fontSize: 6,
        },
        tableTitle: {
          fontSize: 8,
          bold: true,
        },
        mainTitle: {
          fontSize: 17,
          bold: true,
        },
        tableFooter: {
          bold: true,
        },
      },
    };

    pdfMake.createPdf(docDefinition).open();
  }
}
